import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PInputText } from '@porsche-design-system/components-react';
import { forwardRef, useRef } from 'react';

export const ColorPickerInput = forwardRef<
  HTMLInputElement,
  {
    onChange?: (event: { target: { name?: string; value?: string } }) => void;
    onBlur?: () => void;
    value?: string;
    disabled?: boolean;
    name?: string;
    label?: string;
    state?: 'error' | 'none';
    message?: string;
  }
>(function ColorPickerInput(
  { label, state, message, name, value, onChange },
  ref,
) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Container>
      <ColorInput
        ref={(node: HTMLInputElement | null) => {
          inputRef.current = node;
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
        }}
        type="color"
        name={name}
        value={value || '#000000'}
        onChange={onChange}
        state={state}
      />

      <PInputText
        name={name ?? 'color-input'}
        aria-label={label}
        label={label}
        state={state}
        message={message}
        value={`        ${value ?? ''}`}
        onInput={() => {}}
        onFocus={() => inputRef.current?.showPicker()}
      />
    </Container>
  );
});

const Container = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    gap: 'sm',
    position: 'relative',
  },
});

const ColorInput = styled('input', {
  base: {
    position: 'absolute',
    left: 'sm',
    bottom: '13%',
    width: 'lg',
    height: 'lg',
  },

  variants: {
    state: {
      error: { bottom: '35%' },
      none: {},
    },
  },
});
